export const paymentStatusConfig = {
  processing: {
    label: 'Pagamento em processamento',
    backgroundColor: '#FDB022',
  },
  pending: {
    label: 'Pendente',
    backgroundColor: '#FDB022',
  },
  authorized: {
    label: 'Autorizado',
    backgroundColor: '#012F47',
  },
  waiting_payment: {
    label: 'Aguardando Pagamento',
    backgroundColor: '#757575',
  },
  paid: {
    label: 'Pago',
    backgroundColor: '#2E7D32',
  },
  overpaid: {
    label: 'Pago a Maior',
    backgroundColor: '#2E7D32',
  },
  refused: {
    label: 'Recusado',
    backgroundColor: '#D32F2F',
  },
  failed: {
    label: 'Falhou',
    backgroundColor: '#D32F2F',
  },
  canceled: {
    label: 'Cancelado',
    backgroundColor: '#757575',
  },
  refunded: {
    label: 'Reembolsado',
    backgroundColor: '#757575',
  },
  partially_refunded: {
    label: 'Reembolsado Parcialmente',
    backgroundColor: '#757575',
  },
  partial: {
    label: 'Reembolsado Parcialmente',
    backgroundColor: '#757575',
  },
  pending_refund: {
    label: 'Reembolso Pendente',
    backgroundColor: '#ED6C02',
  },
  chargedback: {
    label: 'Estornado (Chargeback)',
    backgroundColor: '#D32F2F',
  },
  underpaid: {
    label: 'Pago a Menor',
    backgroundColor: '#ED6C02',
  },
};

export const inspectionStatusConfig = {
  awaiting_payment: {
    label: 'Aguardando pagamento',
    backgroundColor: '#757575',
  },
  processing: {
    label: 'Vistoria em processamento',
    backgroundColor: '#FDB022',
  },
  ready: {
    label: 'Laudo disponível',
    backgroundColor: '#2E7D32',
  },
};

export const formatPlanType = (planType) => {
  if (!planType) return '';

  switch (planType.toLowerCase()) {
    case 'basic':
      return 'Consulta Autovalid';
    case 'premium':
      return 'Autovalid360';
    default:
      return planType;
  }
};

export const getPaymentStatusDisplay = (status) => ({
  label: paymentStatusConfig[status]?.label || status,
  backgroundColor: paymentStatusConfig[status]?.backgroundColor || '#757575',
});

export const getInspectionStatusDisplay = (inspectionStatus) => ({
  label: inspectionStatusConfig[inspectionStatus]?.label || inspectionStatus,
  backgroundColor: inspectionStatusConfig[inspectionStatus]?.backgroundColor || '#757575',
});

export const HISTORY_TABLE_HEADERS = [
  'Nº Pedido',
  'Plano',
  'Veículo',
  'Criada em',
  'Status do pagamento',
  'Status da vistoria',
  'Valor',
];

export const HISTORY_CLICK_HINT =
  'Clique em um item para visualizar o laudo completo';
